import { Badge, V2ClockIcon } from '@paypalcorp/pp-react';
import * as React from 'react';
export default {
  Badge,
  V2ClockIcon,
  React
};